module.exports = __webpack_public_path__ + "img/lang-25.e80c79c4.jpg";